import "../style.css"
import { useEffect } from "react";

export const PrivacyPolicy = () => {

  useEffect(() => {
    // Update canonical tag
    const canonicalLink = document.querySelector("link[rel='canonical']");
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://saddlefit.io/privacy-policy');
    }

    // Update meta tags and title
    document.title = 'Privacy Policy - SaddleFit.io';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Read SaddleFit.io\'s Privacy Policy to understand how we protect your data and ensure your privacy while using our services.'
      );
    }
  }, []);

  return (
    <div className="main_container">
      <div className="terms_main">
        <h1 className="term_head">Privacy Policy</h1>

        <div className="border_btm"></div>
        <div className="Mb_border_btm"></div>

        <div>
          <h2 className="text_head">Introduction:</h2>
          <p className="paragrah_text">
            This Privacy Policy outlines how Saddle Fit collects, uses,
            maintains, and discloses information collected from users of the
            Saddle Fit software and website.
          </p>

          <h2 className="text_head">Information Collection:</h2>
          <h2 className="text_head">Personal Identification Information:</h2>
          <p className="paragrah_text">
            We may collect personal identification information from Users in
            various ways, including, but not limited to, when Users visit our
            site, register on the site, fill out a form, and in connection with
            other activities, services, features, or resources we make
            available.
          </p>

          <h2 className="text_head">
            Non-personal Identification Information:
          </h2>
          <p className="paragrah_text">
            We may collect non-personal identification information about Users
            whenever they interact with our site. This may include the browser
            name, type of computer, and technical information about Users&apos; means
            of connection to our site.
          </p>

          <h2 className="text_head">How We Use Collected Information:</h2>
          <ul className="list-disc px-2">
            <li className="paragrah_text !font-bold">
              Saddle Fit may collect and use Users&apos; personal information for the
              following purposes:
            </li>
            <p className="px-10">
              <li className="paragrah_text">To improve customer service</li>
              <li className="paragrah_text">To personalize user experience</li>
              <li className="paragrah_text">To improve our site</li>
              <li className="paragrah_text">To process payments</li>
              <li className="paragrah_text">To send periodic emails</li>
            </p>
          </ul>

          <h2 className="text_head">How We Protect Your Information:</h2>
          <p className="paragrah_text">
            We adopt appropriate data collection, storage, and processing
            practices and security measures to protect against unauthorized
            access, alteration, disclosure, or destruction of your personal
            information.
          </p>

          <h2 className="text_head">Sharing Your Personal Information:</h2>
          <p className="paragrah_text">
            We do not sell, trade, or rent Users&apos; personal identification
            information to others.
          </p>
          <p className="paragrah_text">
            We may share generic aggregated demographic information not linked
            to any personal identification information regarding visitors and
            users with our business partners, trusted affiliates, and
            advertisers.
          </p>

          <h2 className="text_head">Web Browser Cookies:</h2>
          <p className="paragrah_text">
            Our Site may use &quot;cookies&quot; to enhance User experience.
          </p>

          <h2 className="text_head">Changes to This Privacy Policy:</h2>
          <p className="paragrah_text">
            Saddle Fit has the discretion to update this privacy policy at any
            time. When we do, we will revise the updated date at the bottom of
            this page.
          </p>

          <h2 className="text_head">Your Acceptance of These Terms:</h2>
          <p className="paragrah_text">
            By using this Site, you signify your acceptance of this policy.
          </p>

          <h2 className="text_head">Contacting Us:</h2>
          <p className="paragrah_text">
            If you have any questions about this Privacy Policy, the practices
            of this site, or your dealings with this site, please contact us.
          </p>

          <h2 className="text_head">Breach of Terms and Conditions:</h2>
          <p className="paragrah_text">
            If you breach these terms and conditions, Saddle Fit may take such
            action as deemed appropriate to deal with the breach.
          </p>

          <h2 className="text_head">Last Updated: 6 FEB 2024</h2>
        </div>
      </div>
    </div>
  );
};
